<template>
    <modal :show.sync=show modalClasses="large-sized-modal modal-hide-footer" headerClasses="pb-0" bodyClasses="p-3">
        <h3 slot="header" class="mb-0 font-weight-500">Payout Details</h3>

        <div v-if="tableData.direct_payout_details.length > 0" class="card-table rounded-bottom">
            <h3>Direct Payout Details</h3>
            <el-table
            :data="tableData.direct_payout_details"
            show-index
            show-summary
            :summary-method="payoutDetailsSummaries"
            style="width: 100%">
                <el-table-column
                    type="index"
                    label="#"
                    width="50"
                ></el-table-column>

                <el-table-column
                    prop="prod_customer_name"
                    label="Customer Name"
                    min-width="160"
                    width="auto"
                >
                    <template slot-scope="scope">
                        <span class="name">
                            {{ scope.row.case.prod_customer_name }}
                        </span>
                        <div>{{ scope.row.case.prod_customer_id }}</div>
                    </template>
                </el-table-column>

                <el-table-column
                    prop="prod_type"
                    label="Product Type"
                    min-width="150"
                    width="auto"
                >
                    <template slot-scope="scope">
                        <div>{{ scope.row.case.prod_type }}</div>
                        <div>{{ scope.row.case.prod_detail_table }}</div>
                    </template>
                </el-table-column>

                <el-table-column
                    prop="case_id"
                    label="Case ID"
                    min-width="90"
                    width="auto"
                >
                    <template slot-scope="scope">
                        {{ scope.row.case.prod_id }}
                    </template>
                </el-table-column>

                <el-table-column
                    prop="comms_payout_summary_id"
                    label="Comms Payout Summary ID"
                    min-width="110"
                    width="auto"
                >
                    <template slot-scope="scope">
                        {{ scope.row.comms_payout_summary_id }}
                    </template>
                </el-table-column>

                <el-table-column
                    prop="user.name"
                    label="User Name"
                    min-width="160"
                    width="auto"
                >
                    <template slot-scope="scope">
                        <span class="name" >
                            {{ scope.row.user.name }}
                        </span>
                    </template>
                </el-table-column>

                <el-table-column
                    prop="payout_level_code"
                    label="Payout Level Code"
                    min-width="120"
                    width="auto"
                >
                    <template slot-scope="scope">
                        {{ scope.row.payout_level_code }}
                    </template>
                </el-table-column>

                <el-table-column
                    prop="payout_percentage"
                    label="Payout Percentage (%)"
                    min-width="120"
                    width="auto"
                >
                    <template slot-scope="scope">
                        {{ scope.row.payout_percentage }}
                    </template>
                </el-table-column>

                <el-table-column
                    prop="actual_payout_revenue_point"
                    label="Payout Revenue Point (RM)"
                    min-width="120"
                    width="auto"
                >
                    <template slot-scope="scope">
                        {{ scope.row.actual_payout_revenue_point | moneyFormatter }}
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <div v-if="tableData.recruitment_payout_details.length > 0" class="card-table rounded-bottom">
            <h3>Recruitment Payout Details</h3>
            <el-table
            :data="tableData.recruitment_payout_details"
            show-index
            show-summary
            :summary-method="payoutDetailsSummaries"
            style="width: 100%">
            <el-table-column
                    type="index"
                    label="#"
                    width="50"
                ></el-table-column>

                <el-table-column
                    prop="prod_customer_name"
                    label="Customer Name"
                    min-width="160"
                    width="auto"
                >
                    <template slot-scope="scope">
                        <span class="name">
                            {{ scope.row.case.prod_customer_name }}
                        </span>
                        <div>{{ scope.row.case.prod_customer_id }}</div>
                    </template>
                </el-table-column>

                <el-table-column
                    prop="prod_type"
                    label="Product Type"
                    min-width="150"
                    width="auto"
                >
                    <template slot-scope="scope">
                        <div>{{ scope.row.case.prod_type }}</div>
                        <div>{{ scope.row.case.prod_detail_table }}</div>
                    </template>
                </el-table-column>

                <el-table-column
                    prop="case_id"
                    label="Case ID"
                    min-width="90"
                    width="auto"
                >
                    <template slot-scope="scope">
                        {{ scope.row.case.prod_id }}
                    </template>
                </el-table-column>

                <el-table-column
                    prop="comms_payout_summary_id"
                    label="Comms Payout Summary ID"
                    min-width="110"
                    width="auto"
                >
                    <template slot-scope="scope">
                        {{ scope.row.comms_payout_summary_id }}
                    </template>
                </el-table-column>

                <el-table-column
                    prop="user.name"
                    label="User Name"
                    min-width="160"
                    width="auto"
                >
                    <template slot-scope="scope">
                        <span class="name" >
                            {{ scope.row.user.name }}
                        </span>
                    </template>
                </el-table-column>

                <el-table-column
                    prop="payout_level_code"
                    label="Payout Level Code"
                    min-width="120"
                    width="auto"
                >
                    <template slot-scope="scope">
                        {{ scope.row.payout_level_code }}
                    </template>
                </el-table-column>

                <el-table-column
                    prop="payout_percentage"
                    label="Payout Percentage (%)"
                    min-width="120"
                    width="auto"
                >
                    <template slot-scope="scope">
                        {{ scope.row.payout_percentage }}
                    </template>
                </el-table-column>

                <el-table-column
                    prop="actual_payout_revenue_point"
                    label="Payout Revenue Point (RM)"
                    min-width="120"
                    width="auto"
                >
                    <template slot-scope="scope">
                        {{ scope.row.actual_payout_revenue_point | moneyFormatter }}
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </modal>
</template>
<script>
import Modal from "@/components/Modal";
import { Table, TableColumn, Select, Option } from 'element-ui'
import {
  notifyFunctionMixin,
  helperFunctionMixin,
  axios,
  services,
  getHeader
} from '@/assets/js/httpImports.js'
import { mapActions,mapState } from 'pinia'
import { useHubStore } from '@/stores/hubStore'
export default {
    props:{
        show_table: Boolean,
    },
    mixins:[
        notifyFunctionMixin,
        helperFunctionMixin
    ],
    components: {
        Modal,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        [Select.name]: Select,
        [Option.name]: Option,
    },
    computed: {
        ...mapState(useHubStore,['current_team', 'date_picked']),
        show: {
            get() {
                return this.show_table;
            },
            set(newVal) {
                this.$emit('update:show_table', newVal);
            },
        },
    },
    data() {
        return {
            tableData: {
                direct_payout_details: [],
                recruitment_payout_details: [],
            },
            sort_by: '',
            hub_id: null,
        }
    },
    watch: {
        date_picked(newValue) {
            if(newValue)
            {
                this.getPayoutDetails();
            }
        },
    },
    created() {
        this.getPayoutDetails();
    },
    methods: {
        payoutDetailsSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = 'Total';
                    return;
                } else if (index === 8) {
                    const values = data.map(item => Number(item[column.property]));
                    if (!values.every(value => isNaN(value))) {
                        sums[index] = values.reduce((prev, curr) => {
                            const value = Number(curr);
                            if (!isNaN(value)) {
                                return prev + curr;
                            } else {
                                return prev;
                            }
                        }, 0).toLocaleString(undefined, {minimumFractionDigits: 2});
                    } else {
                        sums[index] = '';
                    }
                }
            });

            return sums;
        },
        getPayoutDetails() {
            if(this.$route.params.hub_team_id)
            {
                if(this.current_team && this.current_team.hub)
                {
                    this.hub_id = this.current_team.hub.hub_id;
                }
            }
            else
            {
                this.hub_id = this.$route.params.hub_id
            }

            let queryparams = "";
            if(this.date_picked)
            {
                queryparams = '/' + this.date_picked[0] + '/' + this.date_picked[1];
            }

            axios.get(services.hub + 'hub_comms/direct_payout_batch.show_hub_payout_detail/' + this.hub_id + queryparams, { headers: getHeader() })
            .then(res => {
                this.tableData = res.data.data
            })
            .catch ( error => {
                this.errorFunction(error, "Showing Hub Payout Details failed: " + error.response.data.message) 
            });
        }
    }
}
</script>